import React from 'react';
import ZWO_Accepted from '../../assets/icons/zwo-accepted.svg';
import Chip from '@material-ui/core/Chip';
import { AcceptanceStatus } from './SampleAssessment.types';
import { useStyles } from './AcceptanceStatusChip.styles';

interface AcceptanceStatusChipProps {
  status: AcceptanceStatus;
}

const AcceptanceStatusChip: React.FC<AcceptanceStatusChipProps> = ({ status }) => {
  const getAcceptanceStatusCaption = (status: AcceptanceStatus): string[] => {
    switch (status) {
      case AcceptanceStatus.KkAccepted:
        return ['PZWO', 'KK'];
      case AcceptanceStatus.PzwoAccepted:
        return ['PZWO'];
      case AcceptanceStatus.CzwoAssessed:
        return ['Odesłane przez CZWO'];
      default:
        return [];
    }
  };

  const classes = useStyles();
  const label = getAcceptanceStatusCaption(status);

  return !label.length ? (
    <></>
  ) : (
    <span>
      {label.map((e: string) => {
        return (
          <Chip
            key={e}
            className={classes.chip}
            avatar={<img src={ZWO_Accepted} className={classes.avatar} alt='ikona akceptacji ZWO' />}
            label={e}
            variant="outlined"
            size="small"
          />
        );
      })}
    </span>
  );
};

export default AcceptanceStatusChip;
